var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14233 9.58329C2.14233 10.6229 2.3471 11.6524 2.74495 12.6129C3.1428 13.5734 3.72594 14.4461 4.46107 15.1812C5.1962 15.9164 6.06893 16.4995 7.02942 16.8973C7.98992 17.2952 9.01937 17.5 10.059 17.5C11.0986 17.5 12.1281 17.2952 13.0886 16.8973C14.0491 16.4995 14.9218 15.9164 15.6569 15.1812C16.3921 14.4461 16.9752 13.5734 17.373 12.6129C17.7709 11.6524 17.9757 10.6229 17.9757 9.58329C17.9757 8.54366 17.7709 7.51421 17.373 6.55372C16.9752 5.59322 16.3921 4.72049 15.6569 3.98536C14.9218 3.25023 14.0491 2.6671 13.0886 2.26925C12.1281 1.8714 11.0986 1.66663 10.059 1.66663C9.01937 1.66663 7.98992 1.8714 7.02942 2.26925C6.06893 2.6671 5.1962 3.25023 4.46107 3.98536C3.72594 4.72049 3.1428 5.59322 2.74495 6.55372C2.3471 7.51421 2.14233 8.54366 2.14233 9.58329Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1423 16.6666L18.809 18.3333",
    stroke: "#313131",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.243a20f3999049b6cb1aa5152570203b.svg";
export { ForwardRef as ReactComponent };